/* eslint-disable camelcase */
/* eslint-disable no-alert */
import React from 'react'
import { Header, Table } from 'semantic-ui-react'
import firebase from 'firebase/app'

import RequestRow from './RequestRow'

const HEADER = [
  { name: 'Request Date' },
  { name: 'Restaurant' },
  { name: 'Branch' },
  { name: 'Request By' },
  { name: 'Start Close' },
  { name: 'Open After' },
  { name: 'Actions', width: 150 },
]

class RequestList extends React.Component {
  onConfirm = async request => {
    try {
      const { doc_id, merchant_id, branch_id, started_at, ended_at } = request

      const temporaryClosed = {
        end_at: ended_at,
        start_at: started_at,
      }

      const updates = {}
      updates[`restaurants/${merchant_id}/branches/${branch_id}/temporary_closed`] = temporaryClosed

      const confirmation = window.confirm('Are you sure to confirm this request ?')

      if (confirmation) {
        await this.updateRequestStatus(doc_id, 'confirmed')
        await firebase.database().ref().update(updates)
      }

    } catch (error) {
      alert('Failed Update Close Store')
    }
  }

  onCancel = async request => {
    const { doc_id } = request
    try {
      const confirmation = window.confirm('Are you sure to reject this request ?')

      if (confirmation) {
        await this.updateRequestStatus(doc_id, 'rejected')
      }
    } catch (error) {
      alert('Failed to reject request')
    }
  }

  updateRequestStatus = async (doc_id, status) => {
    const { handler } = this.props
    const closeRequestDoc = firebase.firestore().collection('merchant_close_requests').doc(doc_id)

    await closeRequestDoc.update({ status, handler, updated_at: Date.now() })
  }

  renderRows = () => {
    const { requests } = this.props

    return requests.map(request => (
      <RequestRow
        key={request.doc_id}
        request={request}
        onConfirm={() => this.onConfirm(request)}
        onCancel={() => this.onCancel(request)}
      />
    ))
  }

  renderNoData = () => {
    return (
      <Table.Row>
        <Table.Cell key="header" colSpan={HEADER.length} textAlign="center" style={{ padding: 40 }}>
          <Header size="small">No data available</Header>
        </Table.Cell>
      </Table.Row>
    )
  }

  renderFakeRow = () => (
    <Table.Body>
      <Table.Row>
        {HEADER.map(header => {
          return (
            <Table.Cell key={header.name} style={{ paddingTop: 0, paddingBottom: 0 }}>
              {header.width ? <div style={{ width: header.width }} /> : null}
            </Table.Cell>
          )
        })}
      </Table.Row>
    </Table.Body>
  )

  render() {
    const { requests } = this.props

    return (
      <div>
        <div style={{ padding: 14 }}>
          <Table columns={HEADER.length}>
            <Table.Header>
              <Table.Row>
                {HEADER.map((header, ind) => {
                  const { name } = header
                  return (
                    <Table.HeaderCell key={name} textAlign={ind === 0 ? 'left' : 'center'}>
                      {name}
                    </Table.HeaderCell>
                  )
                })}
              </Table.Row>
            </Table.Header>
            {this.renderFakeRow()}
          </Table>
        </div>
        <div
          style={{ overflow: 'auto', padding: '0px 14px' }}
          className="list-content"
        >
          <Table columns={HEADER.length}>
            <Table.Body>{requests.length > 0 ? this.renderRows() : this.renderNoData()}</Table.Body>
          </Table>
        </div>
      </div>
    )
  }
}

export default RequestList



// WEBPACK FOOTER //
// ./src/containers/merchantCloseRequests/components/RequestList.js